<div mat-dialog-content class="info-dialogue-content">
	<mat-tab-group class="pp-tabs" (selectedIndexChange)="onTabChange($event)">
		<mat-tab label="{{ 'mes.production-plan.tabs.info' | translate }}">
			<div class="order-position-info">
				<div>
					<span>{{ 'mes.production-plan.order-position.batch' | translate }}:</span>
					<span>{{ data.batchName }}</span>
				</div>
				<div>
					<span>{{ 'mes.production-plan.order-position.pol' | translate }}:</span>
					<span>{{ data.item.data['pol'] }}</span>
				</div>
				<div>
					<span>{{ 'mes.production-plan.order-position.orderNumber' | translate }}:</span>
					<span>{{ data.item.orderNumber }}</span>
				</div>
				<div>
					<span>{{ 'mes.production-plan.order-position.position' | translate }}:</span>
					<span>{{ data.item.position }}</span>
				</div>
			</div>

			@if (hasTerminalStatuses) {
				<div class="terminal-statuses">
					@for (terminalStatus of terminalStatuses; track terminalStatus.terminalId) {
						@if (terminalStatus.itemOperations.length > 0) {
							<div class="terminal-block">
								@if (getTerminalName(terminalStatus)) {
									<div class="terminal-header">
										<span class="terminal-name">
											{{ getTerminalName(terminalStatus) }}
										</span>
									</div>
								}
								<table class="operation-table">
									<tbody>
										@for (operation of terminalStatus.itemOperations; track $index) {
											<tr>
												<td class="operation-alias">
													{{ operation.alias || 'Operation' }}
												</td>
												<td class="operation-progress-cell">
													@if (getOperationProgress(operation); as progress) {
														<div class="operation-progress">
															<div class="operation-progress-track" [style.background-color]="getStatusTrackColor(progress.status)">
																<div class="operation-progress-bar" [style.background-color]="getStatusBarColor(progress.status)" [style.width.%]="progress.percent"></div>
															</div>
															<span class="operation-progress-text">
																{{ progress.text }}
															</span>
														</div>
													}
												</td>
											</tr>
										}
									</tbody>
								</table>
							</div>
						}
					}
				</div>
			}
		</mat-tab>

		<mat-tab label="{{ 'mes.production-plan.tabs.path' | translate }}">
			<app-production-plan-path [terminalStatuses]="data.terminalStatuses ?? []" [terminalNames]="data.terminalNames" [nodeColorById]="nodeColorById" [isFullscreen]="isFullscreen" (fullscreenToggle)="onFullscreenToggle()"></app-production-plan-path>
		</mat-tab>
	</mat-tab-group>
</div>

<div mat-dialog-actions align="end">
	<button mat-flat-button color="primary" (click)="close()">
		{{ 'general.close' | translate }}
	</button>
</div>
